import LegalPageLayout, { Sec, List } from "@/components/legal/LegalPageLayout";
import { LEGAL_DOCUMENTS } from "@/lib/legalDocuments";

export default function CommunicationsConsent() {
  return (
    <LegalPageLayout
      document={LEGAL_DOCUMENTS.tcpa}
      seoDescription="TCPA & Electronic Communications Consent for Hannah Howard Funding."
    >
      <Sec n="1" title="Purpose">
        <p>This Telephone, SMS, and Electronic Communications Consent ("Consent") explains how Hannah Howard Funding ("Hannah Howard Funding," "we," "our," or "us") may communicate with you after you voluntarily provide your contact information through our website, application, telephone conversations, email, SMS, or other communication channels.</p>
        <p>This Consent supplements our Privacy Policy, Terms of Use, Funding Agreement (if applicable), and other agreements between you and Hannah Howard Funding.</p>
      </Sec>

      <Sec n="2" title="Consent to Communications">
        <p>By voluntarily providing your telephone number, email address, or other contact information, you expressly authorize Hannah Howard Funding and its authorized service providers to contact you regarding:</p>
        <List items={[
          "funding inquiries;",
          "commission advance applications;",
          "underwriting;",
          "verification requests;",
          "document collection;",
          "funding decisions;",
          "transaction updates;",
          "servicing;",
          "repayment administration;",
          "appointment scheduling;",
          "customer support;",
          "account administration;",
          "fraud prevention;",
          "security notifications;",
          "legally required communications.",
        ]}/>
        <p>Communications may be delivered using:</p>
        <List items={[
          "telephone calls;",
          "SMS text messages;",
          "MMS messages;",
          "email;",
          "voicemail;",
          "secure messaging;",
          "other electronic communication methods permitted by applicable law.",
        ]}/>
      </Sec>

      <Sec n="3" title="Automated Communications">
        <p>Where applicable and where you have provided the required consent, communications may be delivered using:</p>
        <List items={[
          "automatic telephone dialing technology;",
          "automated messaging platforms;",
          "prerecorded or artificial voice technology;",
          "automated SMS systems.",
        ]}/>
        <p>These technologies may be used to improve customer service, deliver application updates, schedule appointments, provide reminders, verify information, or communicate regarding existing transactions.</p>
        <p>If Hannah Howard Funding does not use one or more of these technologies, this section should be modified accordingly before publication.</p>
      </Sec>

      <Sec n="4" title="Marketing Communications">
        <p>If you separately consent to receive promotional communications, Hannah Howard Funding may send information regarding:</p>
        <List items={[
          "new services;",
          "educational content;",
          "promotional offers;",
          "company announcements;",
          "newsletters;",
          "events.",
        ]}/>
        <p>Providing consent to receive marketing communications is not required as a condition of:</p>
        <List items={[
          "submitting an application;",
          "receiving funding;",
          "obtaining customer support; or",
          "using our Services.",
        ]}/>
      </Sec>

      <Sec n="5" title="Standard Messaging Charges">
        <p>Message and data rates may apply according to your wireless carrier plan.</p>
        <p>You are solely responsible for any charges imposed by your wireless provider.</p>
        <p>Message frequency may vary depending upon your interactions with Hannah Howard Funding.</p>
      </Sec>

      <Sec n="6" title="Opting Out">
        <p>You may opt out of marketing SMS communications at any time by:</p>
        <List items={[
          "replying STOP to a text message where applicable;",
          "following instructions contained within the communication; or",
          "contacting Hannah Howard Funding directly.",
        ]}/>
        <p>After opting out, you may continue to receive transactional or legally required communications relating to:</p>
        <List items={[
          "pending applications;",
          "existing funding transactions;",
          "account servicing;",
          "fraud prevention;",
          "legally required notices.",
        ]}/>
      </Sec>

      <Sec n="7" title="HELP Requests">
        <p>Where supported by our messaging platform, replying HELP may provide additional contact information or customer support instructions.</p>
        <p>You may also contact us directly using the contact information provided at the end of this Consent.</p>
      </Sec>

      <Sec n="8" title="Updating Contact Information">
        <p>You agree to promptly notify Hannah Howard Funding if your:</p>
        <List items={[
          "telephone number;",
          "email address;",
          "mailing address; or",
          "other contact information changes.",
        ]}/>
        <p>Failure to maintain current contact information may delay communications regarding your application or funded transaction.</p>
      </Sec>

      <Sec n="9" title="Revocation of Consent">
        <p>Where permitted by law, you may withdraw certain communications consent by contacting Hannah Howard Funding.</p>
        <p>Withdrawal of consent may affect our ability to:</p>
        <List items={[
          "process your application;",
          "communicate regarding funding;",
          "administer existing transactions; or",
          "provide requested Services.",
        ]}/>
        <p>Withdrawal of consent does not affect communications that are legally required or otherwise permitted under applicable law.</p>
      </Sec>

      <Sec n="10" title="Carrier Disclaimer">
        <p>Wireless carriers are not liable for delayed or undelivered messages.</p>
        <p>Delivery depends upon your wireless provider, network availability, device compatibility, and other factors outside the control of Hannah Howard Funding.</p>
      </Sec>

      <Sec n="11" title="Changes to this Consent">
        <p>We may revise this Consent from time to time.</p>
        <p>The Effective Date above reflects the most recent version.</p>
        <p>Continued use of the Services after revised communications practices become effective constitutes acknowledgment of the updated Consent to the extent permitted by applicable law.</p>
      </Sec>

      <Sec n="12" title="Contact Information">
        <p>Questions regarding this Consent may be directed to:</p>
        <p>
          Hannah Howard Funding<br />
          Email: hello@hannahhowardfunding.com<br />
          Phone: (870) 919-9520<br />
          Mailing Address: 495 Brickell Ave Miami, FL 33131
        </p>
      </Sec>
    </LegalPageLayout>
  );
}
